import { createFileRoute } from '@tanstack/react-router'

import { AiSettings } from '@/components/Internal/System/AiSettings'

export const Route = createFileRoute('/internal/system/settings/ai')({
  component: AiSettings,
})
